import angular from 'angular';
import template from './scopesDropdown.html';
import './scopesDropdown.scss';

export class ScopesDropdownController {
  constructor($element, $timeout, KEY_CODES) {
    'ngInject';

    [this.$element] = Array.from($element);
    this.$timeout = $timeout;
    this.KEY_CODES = KEY_CODES;
    this.isOpen = false;
    this.selectedScope = {};
    this._preventNextOpen = false;
    this._preventNextClose = false;
    this._checkboxesSelector = 'input[type="checkbox"]';
    this._previousSemiSelectedScopes = [];
  }
  $onInit() {
    this._previousSemiSelectedScopes = this.semiSelectedScopes.slice();
    this._markIndeterminate();
  }
  $doCheck() {
    if (!angular.equals(this.semiSelectedScopes, this._previousSemiSelectedScopes)) {
      this._markIndeterminate();
      this._previousSemiSelectedScopes = this.semiSelectedScopes.slice();
    }
  }
  open() {
    if (!this.disableDropdown) {
      if (this._preventNextOpen) {
        this._preventNextOpen = false;
      } else {
        this.isOpen = true;
      }
    }
  }
  close() {
    if (this._preventNextClose) {
      this._preventNextClose = false;
    } else {
      this.isOpen = false;
    }
  }
  toggle() {
    if (this.isOpen) {
      this.close();
    } else {
      this.open();
    }
  }
  toggleSelectedScope() {
    this._preventNextOpen = true;
    this.$timeout(() => {
      this.onToggle({
        scope: this.selectedScope,
      });
    });
  }
  toggleScope(scope) {
    this._preventNextClose = true;
    this.$timeout(() => {
      this.onToggle({ scope });
    });
  }
  select(scope) {
    this.selectedScope = scope;
    this.onSelect({ scope });
    this.close();
  }
  keyup($event) {
    if ($event.keyCode === this.KEY_CODES.enter) {
      this.toggle();
    }
  }
  _markIndeterminate() {
    this.$timeout(() => {
      const boxes = [...this.$element.querySelectorAll(this._checkboxesSelector)];
      boxes.forEach((box) => {
        box.indeterminate = box.dataset.isIndeterminated === 'true';
      });
    });
  }
}

export default {
  controller: ScopesDropdownController,
  template,
  bindings: {
    id: '@',
    placeholder: '@',
    scopes: '<',
    selectedScopes: '<',
    semiSelectedScopes: '<',
    onToggle: '&',
    onSelect: '&',
  },
};
